import * as React from 'react';
import { getRelativeBasePath } from '@helpCenter/util/history';
import { getCloudId, getWorkspaceAri } from '@helpCenter/util/meta';
import { graphql, useLazyLoadQuery } from 'react-relay';
import * as grid from 'view/styles/grid';
import { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import { Box, xcss } from '@atlaskit/primitives';
import type { multiHcDropdownContentQuery } from './__generated__/multiHcDropdownContentQuery.graphql';

interface Props {
    helpCenterLength: number;
}
export const MultiHcDropdownContent: React.FC<Props> = ({ helpCenterLength }: Props) => {
    const data = useLazyLoadQuery<multiHcDropdownContentQuery>(
        graphql`
            query multiHcDropdownContentQuery($cloudId: ID!, $workspaceAri: ID!) {
                helpCenter(cloudId: $cloudId) {
                    helpCenters(workspaceAri: $workspaceAri) {
                        #TODO: use connections and edges here to support pagination in future
                        ... on HelpCenter {
                            name {
                                default
                            }
                            slug @optIn(to: "HelpCenterSlugTest")
                        }
                        ... on QueryError {
                            __typename
                        }
                    }
                }
            }
        `,
        {
            cloudId: getCloudId(),
            workspaceAri: getWorkspaceAri(),
        }
    );
    const handleClick = React.useCallback((url: string) => {
        window.location.href = url;
    }, []);

    const hasQueryError = data.helpCenter?.helpCenters?.some((hc) => hc?.__typename === 'QueryError');
    if (hasQueryError) {
        return null;
    }

    const helpCenters =
        data.helpCenter?.helpCenters
            ?.map((hc) => {
                if (hc?.slug) {
                    return {
                        hcname: hc?.name?.default || 'Help Center',
                        url: `/helpcenter/${hc?.slug}`,
                    };
                }
                //default helpcenter as slug is null
                return {
                    hcname: hc?.name?.default || 'Help Center',
                    url: '/servicedesk/customer',
                };
            })
            //not showing the already selected HC in dropdown
            .filter((hc) => hc?.url !== getRelativeBasePath())
            // showing only n helpcenters in dropdown, this will be changed when this query gets paginated
            .slice(0, helpCenterLength) || [];

    return (
        <>
            <DropdownItemGroup>
                {helpCenters.map((hc) => (
                    <DropdownItem key={hc.url} onClick={() => handleClick(hc.url)}>
                        <Box xcss={menuItemStyles}>{hc.hcname}</Box>
                    </DropdownItem>
                ))}
            </DropdownItemGroup>
        </>
    );
};

const menuItemStyles = xcss({
    color: 'color.text',
    textDecoration: 'none',
    maxWidth: grid.multiple(28).px,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
});
